import { Injectable, OnDestroy, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';
import { concatMap, takeUntil } from 'rxjs/operators';

import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { NotificationType } from 'angular2-notifications';
import { Mapper } from 'src/app/core/data/mapper';
import { PushNotificationData } from '../../shared/model/push-notification-model';
import { NotificationToastService } from './notifications-toast.service';
import { NotificationsRepository } from 'src/app/core/data/repository/notifications-repository';

@Injectable()
export class PushNotificationService implements OnDestroy {
  private notificationUpdate = new BehaviorSubject(null);
  private destroy$ = new Subject();

  public notificationUpdate$ = this.notificationUpdate.asObservable();

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private notificationToastService: NotificationToastService,
    private mapper: Mapper,
    private notificationsRepository: NotificationsRepository
  ) {}

  ngOnDestroy() {
    this.destroy$.complete();
  }

  getToken(): Observable<string> {
    return this.angularFireMessaging.getToken;
  }

  receiveMessage(): Observable<any> {
    return this.angularFireMessaging.messages;
  }

  requestPermission(): Observable<string> {
    return this.angularFireMessaging.requestPermission.pipe(
      concatMap((notificationPermission) => {
        if (notificationPermission === 'granted') {
          return this.getToken();
        }
        return EMPTY;
      }),
      concatMap((token) => this.notificationsRepository.updateAdminNotificationToken(token)),
      takeUntil(this.destroy$)
    );
  }

  messagingSetup(componentRef: ViewContainerRef): void {
    this.requestPermission()
      .pipe(
        concatMap(() => this.receiveMessage()),
        takeUntil(this.destroy$))
      .subscribe({
        next: (payload) => {
          payload.notification['NotificationType'] = NotificationType.Info;
          payload.notification['data'] = this.mapper.fromJson(PushNotificationData, payload.data);
          this.notificationToastService.SnackBar(payload.notification, componentRef);
          this.notificationUpdate.next(payload.notification);
        },
      });
  }
}
